import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import Table from 'components/common/Table';

import { vendorApi } from 'api';

import { VENDOR_LIST_COLUMNS, VENDOR_FILTER_OPTIONS } from 'constants/vendor';

import paths from 'routes/paths';

const Vendors = () => {
  const navigate = useNavigate();

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => navigate(paths.vendorCreate)}
    >
      Create Vendor
    </Button>
  );

  return (
    <Table
      title="Vendor List"
      apiService={vendorApi}
      sortable={true}
      columns={VENDOR_LIST_COLUMNS}
      filterOptions={VENDOR_FILTER_OPTIONS}
      headerActions={headerActions}
    />
  );
};

export default Vendors;
